export default function rotateDeg (i){
    return this.startDeg + this.rotateUnit * i;
}